import type { ICustomControlProcedureReadProps } from '../../interfaces/';
import { OsasV1QuestionnairesRead } from '../../utils/v1/questionnaires/OsasQuestionnairesRead';

export function OsasoV1QuestionnairesRead(props: ICustomControlProcedureReadProps) {
    return (
        <OsasV1QuestionnairesRead
            {...props}
            showHeader
        />
    );
}
